module.exports = __webpack_public_path__ + "img/happy2.cf68c6e7.png";